import React from 'react';
import styles from './PriceSelector.module.scss';
import {roundTo} from 'round-to';
import {
  calculateCommission,
  calculateMinimum,
  calculateMoneyTransferCost,
  calculateProfit,
  commissionCostPercent
} from 'data/utils/calculators';
import Slider from './components/slider';
import PriceRow from './components/priceRow/PriceRow';
import {
  generateSavingsNumber,
  generateSavingsPercent,
} from 'gui/components/listPage/components/ad/components/adPurchase/components/adSavings';
import Divider from '@material-ui/core/Divider';

interface IPriceSelectorProps {
  valuePrice?: number;
  askingPrice?: number;
  changePrice?: number;
  currency?: number;
  setAskingPrice?: (askingPrice: number) => void;
}


const PriceSelector = ({changePrice, valuePrice, askingPrice, setAskingPrice, currency}: IPriceSelectorProps) => {

  const error = '';
  const minPossiblePrice = changePrice && changePrice > 0 ? calculateMinimum(changePrice) : 1;
  const min = Math.round(minPossiblePrice);
  const max = Math.round(valuePrice);
  const moneyTransferCost = calculateMoneyTransferCost(askingPrice);
  const commission = calculateCommission(askingPrice);
  const profit = calculateProfit(askingPrice, changePrice, moneyTransferCost, commission);
  const discountPercent = generateSavingsPercent(valuePrice, askingPrice);
  const discount = generateSavingsNumber(valuePrice, askingPrice);
  return (
    <div className={`${styles.PriceSelector} ${(error ? `${styles.error} ` : "")}`}>
      <div className={styles.innerPriceSelector}>
        <Slider
          min={min}
          max={max}
          value={Math.floor(askingPrice || min)}
          onChange={(event, value: number) => setAskingPrice(roundTo(value, 0))}
        />
        <PriceRow label="שווי שוברים / כרטיסים" value={valuePrice} currency={currency}/>
        <PriceRow label="מחיר מכירה" value={askingPrice} currency={currency} editor={{name: "askingPrice", min, max}}/>
        <PriceRow
          label={`הנחה לקונה (${discountPercent}%)`} value={discount} currency={currency}/>
        <PriceRow label="עלות שינוי למוכר" value={changePrice} currency={currency}/>
        <Divider style={{marginTop: 20}}/>
        <PriceRow label={`עלות שירות (${commissionCostPercent}%)`} value={commission} currency={currency}/>
        <Divider style={{marginTop: 20}}/>
        <PriceRow label="יתרה למוכר" value={profit} currency={currency} conclusion/>
      </div>
    </div>
  );
};

PriceSelector.defaultProps = {
  changePrice: 0,
  valuePrice: 0,
  currency: 2,
};

export default React.memo(PriceSelector);
